/** 截止时间倒计时描述 */
export function dueCountdown(dueDate?: string | null): {
  text: string;
  level: 'none' | 'overdue' | 'urgent' | 'normal';
} {
  if (!dueDate) return { text: '', level: 'none' };
  const due = new Date(dueDate).getTime();
  const diff = due - Date.now();
  if (diff <= 0) return { text: '已逾期', level: 'overdue' };
  const hours = Math.floor(diff / 3_600_000);
  const days = Math.floor(hours / 24);
  const restHours = hours % 24;
  if (days > 0) {
    return { text: `剩余 ${days} 天${restHours > 0 ? ` ${restHours} 小时` : ''}`, level: 'normal' };
  }
  if (hours > 0) {
    return { text: `剩余 ${hours} 小时`, level: 'urgent' };
  }
  const minutes = Math.max(1, Math.floor(diff / 60_000));
  return { text: `剩余 ${minutes} 分钟`, level: 'urgent' };
}

/** 统一日期时间格式化：2026-08-23 15:30 */
export function formatDateTime(iso?: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`;
}
